import { cache } from '@/container/apollo-client/cache';
import { QUERY_GET_WALLET_DETAILS } from '@/graphql/query.graphql';
import { usewalletDetailsSubscription } from '@/types/generated/graphql';

export function useWalletSubscription() {
  usewalletDetailsSubscription({
    onData: (res) => {
      cache.writeQuery({
        query: QUERY_GET_WALLET_DETAILS,
        data: {
          getWalletDetailsV2: {
            __typename: 'WalletResponse',
            message: '',
            data: {
              __typename: 'WalletDetails',
              amount: res?.data?.data?.walletDetails?.amount,
            },
          },
        },
      });
    },
  });
}
